module.exports = __webpack_public_path__ + "static/img/badge-larvicide-scheduled-mandatory.f1b9329.svg";